/**
 * Created by lowdev on 1/4/18.
 */
import template from './StaffCard.html'

class Staff {
  constructor (id, user, url) {
    this.id = id
    this.user = user
    this.url = url
    this.template = template
  }

  renderCard () {
    return eval('`' + this.template + '`')
  }
}

export default Staff



// WEBPACK FOOTER //
// ./accounts/pro/static/js/models/Staff.js